import Business from './Business'
import { Container, LabelRow, SubTitle } from './styles'

export default function DashboardBusinessesList ({ businesses = [] }) {
  return businesses?.length > 0 && ( 
    <Container>
      <LabelRow>
        <SubTitle style={{justifySelf: 'flex-start'}}>Nome</SubTitle>
        <SubTitle>Agendamentos realizados</SubTitle>
        <SubTitle style={{justifySelf: 'flex-end'}}>Total faturado</SubTitle>
      </LabelRow>
      {businesses.map ((business, index) => (
        <Business key={index} data={business}/>
      ))}
    </Container>
  )
}
